import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import HeaderMobileMenu from "../header-mobile-menu/component";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class HeaderHomeTwo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: "",
            user: null,
            lang: null,
            modal: false,
            dropwdown: false,
            languages: []
        };
    };

    componentWillMount() {
        this._updateUser();
        this._updateView();
        this._updateLang();
        this._updateLanguages();
    }

    _updateLang(){
        this.setState({
            lang: langRegister.lang()
        });
    }

    _updateUser() {
        this.setState({
            user: userRegister.get()
        });
    }

    _updateView() {
        if (this.props.view) {
            this.setState({
                view: this.props.view
            });
        } else {
            this.setState({
                view: "register"
            });
        }
    }

    _updateLanguages() {
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if(Array.isArray(languages)){
            this.setState({languages: languages});
        }
    }

    _signout() {
        userRegister.remove();
        tokenRegister.remove();
        demoRegister.remove();
        window.location.reload();
    }

    _openMenu () {
        this.child._openMenu();
    }

    _home() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
        } catch (e) {}
    }

    _register() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/register");
        } catch (e) {
        }
    }

    _profile(){
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
        } catch (e) {}
    }

    _login() {
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
    }

    _setLang(prop){
        if(prop.toLowerCase() !== langRegister.lang().toLowerCase()){
            let string = "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name');
            let re = new RegExp(string,"g");
            let url = this.props.props.location.pathname.replace(re,'');
            langRegister.set(prop);
            this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + url);
            window.location.reload();
        }else{
            this.setState({dropwdown: false});
        }
    }

    _renderText(item) {
        return langRegister.get("signup-header-one", item, "sv");
    }

    render() {
        return (
            <div>
                {
                    this.state.modal &&
                    <div className={Styles.overlay}>
                        <div className={Styles.overlayModal}>
                            <div className={Styles.overlayModalInner}>
                                <img onClick={() => this.setState({modal: false})}
                                     className={Styles.overlayCloseButton}
                                     src={require("../../assets/images/close_icon.svg")}/>
                                <div>
                                    <div className={Styles.overlayModalTitle}>
                                        {this._renderText("item_4")}
                                    </div>
                                    <div className={Styles.overlayModalText}>
                                        <span className={Styles.overlayModalTextBold}>{this._renderText("item_5")}</span> {this._renderText("item_6")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.overlayModalButtons}>
                                <div className={Styles.overlayModalButtonsItem}>
                                    <div onClick={() => this.setState({modal: false})}
                                         className={Styles.overlayModalButtonsItemButton}>
                                        {this._renderText("item_7")}
                                    </div>
                                </div>
                                <div className={Styles.overlayModalButtonsItem}>
                                    <div onClick={() => {
                                        this._profile();
                                    }} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                        {this._renderText("item_8")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className={Styles.header}>
                    {
                        this.state.dropwdown &&
                        <div onClick={() => this.setState({dropwdown: false})} className={Styles.languageButtonContainerOverlay}/>
                    }
                    {
                        this.state.view !== "vip" &&
                        <div className={Styles.logoContainer}>
                            <img onClick={() => this._home()} className={Styles.logoContainerIcon}
                                 src={salesChannelRegister.get('logo')}/>
                            <img onClick={() => this._home()} className={Styles.logoContainerIconMobile}
                                 src={salesChannelRegister.get('logo_mobile')}/>
                        </div>
                    }
                    {
                        this.state.view === "vip" &&
                        <div className={Styles.logoContainer}>
                            <img onClick={() => this.setState({leave: true, home: true})} className={Styles.logoContainerIconTwo}
                                 src={require("../../assets/images/Saleschannel_Logotype_RGB_Black_2.svg")}/>
                        </div>
                    }
                    <div className={Styles.menuContainer}></div>

                    {
                        this.state.view !== "vip" &&
                        <div className={Styles.buttonContainer}>
                            <div className={Styles.languageButtonContainer}>
                                <div onClick={() => this.setState({dropwdown: !this.state.dropwdown})} className={Styles.languageButton}>
                                    {this.state.lang}
                                </div>
                                {
                                    this.state.dropwdown &&
                                    <div>
                                        <div className={Styles.languageButtonDropdown}>
                                            {
                                                this.state.languages.map((item) => {
                                                    return(
                                                        <div onClick={() => this._setLang(item.code)} className={Styles.languageButtonDropdownItem}>
                                                            {item.names[langRegister.lang()]}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className={Styles.languageButtonTriangle}/>
                                    </div>
                                }
                            </div>
                            {
                                this.state.user &&
                                <img onClick={() => this._profile()} className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon.svg")}/>
                            }
                            {
                                !this.state.user && this.state.view === "login" &&
                                <div onClick={() => this._register()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_1")}
                                </div>
                            }
                            {
                                !this.state.user && (this.state.view === "register" || this.state.view === "about") &&
                                <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_3")}
                                </div>
                            }
                            {
                                this.state.user &&
                                <div onClick={() => this._signout()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_2")}
                                </div>
                            }
                            <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                                 src={require("../../assets/images/menu_icon.svg")}/>
                        </div>
                    }
                    <HeaderMobileMenu props={this.props.props} ref={instance => {this.child = instance}} layout={true}/>
                </div>
            </div>
        );
    }
}

export default HeaderHomeTwo;


// WEBPACK FOOTER //
// ./src/components/header-home-two/component.js